import {
  SELECT_EXISTING_CLEAR_PEOPLE,
  SELECT_EXISTING_LOAD_PEOPLE,
} from '../actionConstants';

const defaultState = {
  people: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SELECT_EXISTING_LOAD_PEOPLE:
      return {
        people: action.people || [],
      };
    case SELECT_EXISTING_CLEAR_PEOPLE:
      return {
        ...state,
        people: [],
      };
    default:
      return state;
  }
};
